export default __webpack_public_path__ + "static/home-background3-5facac3948ae2c9a2f25240cfcc2ad45.jpg";